import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, UrlSegment } from "@angular/router";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { EventsHubService, ExamMessage, EXAMMESSAGETYPE } from "src/app/services/eventshub.service";
import { UserAuthService } from "src/app/services/userauth.service";
import { ExamService } from "src/app/services/exam.service";
import { UploadButtonCompleteResponse } from "src/app/directives/uploadbutton.directive";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { PageObjectUploadButton } from "src/app/models/pageobjectuploadbutton";

@Component({
  selector: "hkt-pageobjectuploadbutton",
  templateUrl: "./pageobjectuploadbutton.component.html",
  styleUrls: ["./pageobjectuploadbutton.component.scss"],
})
export class PageObjectUploadButtonComponent implements OnInit {
  @Input("obj") obj: PageObjectUploadButton;
  @Input("mode") mode: string;

  uploadUrl: string;
  uploadFolder: string;
  uploadingFile: boolean;
  uploadingProgress: number;
  routerParams: Subscription;
  extensions: string;

  constructor(
    private eventsHubService: EventsHubService,
    private modalDialogService: ModalDialogService,
    userAuthService: UserAuthService,
    examService: ExamService,
    activatedRoute: ActivatedRoute,
  ) {
    this.uploadUrl = Config.SERVER_API_UPLOAD;

    activatedRoute.url.subscribe((value: UrlSegment[]) => {
      if (value[0].path == "evaluate") {
        this.uploadFolder = Config.SERVER_UPLOADFOLDER + "/" + examService.currentUser.id;
      } else {
        this.uploadFolder = Config.SERVER_UPLOADFOLDER + "/" + userAuthService.currentUser.id;
      }
    });

    this.uploadingFile = false;
    this.uploadingProgress = 0;
    this.extensions = "";
  }

  ngOnInit(): void {
    if (this.obj.uploadType == "pdf") {
        this.extensions = "PDF Files|pdf";
    } else if (this.obj.uploadType == "image") {
        this.extensions = "Images|png,jpg";
    } else if (this.obj.uploadType == "video") {
        this.extensions = "Video Files|mp4";
    }
  }

  onUploadProgress(progress: number): void {
    this.uploadingFile = true;
    this.uploadingProgress = progress;
  }
  onUploadComplete(data: UploadButtonCompleteResponse, controlName: string): void {
    this.obj.fileSrc = data.filename;
    this.uploadingFile = false;

    let msg = new ExamMessage();
    msg.type = EXAMMESSAGETYPE.RunAction;
    msg.data = "SaveExam()";
    this.eventsHubService.setExamMessage(msg);
  }
  onUploadError(msg: string): void {
    this.modalDialogService.showAlert(Config.APP_NAME, msg);
    this.uploadingFile = false;
  }
}
